import { render, staticRenderFns } from "./pay-icon-box.vue?vue&type=template&id=10bf50f2&scoped=true"
import script from "./pay-icon-box.vue?vue&type=script&lang=js"
export * from "./pay-icon-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf50f2",
  null
  
)

export default component.exports